import { Tabs } from '@heroui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { mobileTabNavItems } from './nav-items';

function getActiveTabPath(pathname: string): string | null {
  const match = mobileTabNavItems.find((item) =>
    item.to === '/dashboard' ? pathname === '/dashboard' : pathname.startsWith(item.to),
  );
  return match?.to ?? null;
}

export function AppMobileTabBar() {
  const location = useLocation();
  const navigate = useNavigate();
  const activeTab = getActiveTabPath(location.pathname);

  return (
    <nav
      aria-label="Navegação principal"
      data-tour="mobile-tab-bar"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-separator bg-surface shadow-[0_-4px_24px_rgba(0,0,0,0.06)] md:hidden dark:shadow-[0_-4px_24px_rgba(0,0,0,0.35)]"
    >
      <Tabs
        selectedKey={activeTab ?? undefined}
        onSelectionChange={(key) => navigate(String(key))}
        className="w-full pb-[env(safe-area-inset-bottom)]"
      >
        <Tabs.ListContainer className="w-full px-2 py-2">
          <Tabs.List
            aria-label="Navegação principal"
            className="grid w-full grid-cols-4 gap-1.5 bg-transparent p-0"
          >
            {mobileTabNavItems.map(({ to, label, shortLabel, icon: Icon }) => (
              <Tabs.Tab
                key={to}
                id={to}
                className="relative flex min-h-[3.75rem] w-full min-w-0 flex-col items-center justify-center gap-0.5 rounded-2xl px-0.5 py-1.5 text-[10px] leading-[1.1] text-muted transition-colors data-[selected=true]:font-semibold data-[selected=true]:text-accent"
              >
                <Tabs.Indicator className="inset-0 rounded-2xl bg-accent/12 shadow-none dark:bg-accent/20" />
                <Icon size={20} strokeWidth={1.75} className="relative z-[1] shrink-0" />
                <span className="relative z-[1] max-w-full whitespace-pre-line text-center">
                  {shortLabel ?? label}
                </span>
              </Tabs.Tab>
            ))}
          </Tabs.List>
        </Tabs.ListContainer>
      </Tabs>
    </nav>
  );
}
